import styled from "styled-components";
import { IconOSNew } from "../../MapInfoSemaforo/IconsMap";

interface StatusTagProps {
  status: string | undefined;
  orderService: any
}

function StatusTag({ status, orderService }: StatusTagProps) {

  function getStatusColor() {
    if (status === "AguardandoAtivacao" || status === "Cancelada") {
      return { backgroundColor: "#f5f5f5", color: "#616161" }
    }
    if (status === "Planejada") {
      return { backgroundColor: "#e3f2fd", color: "#1976d2" }
    }
    if (status === "ExecutadaParcialmente") {
      return { backgroundColor: "#fff3e0", color: "#e65100" }
    }
    if (status === "Executada") {
      return { backgroundColor: "#e8f5e9", color: "#2e7d32" }
    }
    if (status === "Atrasada") {
      return { backgroundColor: "#ffebee", color: "#e74c3c" }
    }
  }

  function getStatusText() {
    if (status === "AguardandoAtivacao") {
      return "AGUARDANDO ATIVAÇÃO";
    }
    if (status === "Planejada") {
      return "PLANEJADO";
    }
    if (status === "ExecutadaParcialmente") {
      return "EXECUTADO PARCIALMENTE";
    }
    if (status === "Executada") {
      return "EXECUTADO";
    }
    if (status === "Atrasada") {
      return "ATRASADA";
    }
    if (status === "Cancelada") {
      return "CANCELADA";
    }
  }

  const Icon = <IconOSNew width={16} height={18} heightSpec={1} style={{ position: 'absolute', left: 20, top: 16 }} />
  return (
    <>
      {status ? (
        <Container style={getStatusColor()}>
          {orderService?.possuiVinculoOrdemServico ? Icon : null}
          <p>{getStatusText()}</p>
        </Container>
      ) : (
        <span>-</span>
      )}
    </>
  );
}

const Container = styled.div`
  padding: 6px;
  border-radius: 15px;
  font-weight: bold;
  font-size: 0.70rem;

  p {
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
      display: inline-block;
      max-width: 110px; /* ajusta conforme o espaço */
      text-align: center;
  }
`;

export default StatusTag;
